<template>
    <div class="detail-page">
        <div class="detail-main">
            <div class="header">
                <div style="border:1px solid #fff">
                    <p>政策详情</p>
                </div>
            </div>
            <div class="body">
                <div class="news-title">{{ detail.newName }}</div>
                <div class="info">
                    <span>{{ detail.addTime }}</span>
                    <span>来源：{{ detail.typeName }}</span>
                </div>
                <div class="content" v-html="detail.newContent">
                </div>
            </div>
        </div>
        <div class="footer"></div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            detail:{}
        };
    },
    computed:{
        newId(){
            return this.$route.query.newId
        }
    },
    mounted() {
        this.$http.getNewsDetail({newId:this.newId}).then(res=>{
            if(res.success){
                this.detail = res.ptNew
            }
        })
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
@import "@/scss/home/news.scss";
</style>